import './loader.scss'

import { FC } from 'react'
import { Image, Modal } from 'react-bootstrap'
import { loader_icon } from 'src/assets'
import { loader_t } from 'src/types'

export const Loader: FC<loader_t> = ({ overlay, hidden }: loader_t) => {
  return (
    <main>
      {!hidden && (
        <>
          {overlay ? (
            <Modal centered show={overlay} animation={false} className="loader-modal">
              <Image src={loader_icon} className="loader filter-white" />
            </Modal>
          ) : (
            <Image src={loader_icon} className="loader filter-accent" />
          )}
        </>
      )}
    </main>
  )
}
